import { createContext, useContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

	const [token, setToken] = useState(() => localStorage.getItem("admintoken") || null);
	const [loggedUser, setLoggedUser] = useState({});
	const [dashboard, setDashboard] = useState(false);


	const storeTokenInLS = async (serverToken) => {
		localStorage.setItem('token', serverToken);
		setToken(serverToken);
	};

	const userAuthentication = async () => {

		if (!token) return;

		try {
			console.log(token, "Authenticating user...");
			const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/fetch-profile`, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			const responseData = await response.json();

			if (response.ok && responseData.status === 200) {
				setLoggedUser(responseData.user || {});
				const permissionss = responseData?.user?.role?.permissions.find(p => p.path === "/dashboard");
				if (permissionss?.isVisible) {
					setDashboard(true);
				} else {
					setDashboard(false);
				}
			} else {
				setLoggedUser({});
			}
		} catch (error) {
			console.error("Error fetching user data:", error);
			setLoggedUser({});
		}
	};

	useEffect(() => {
		userAuthentication();

	}, [token]);

	return (
		<>
			<AuthContext.Provider value={{ loggedUser, setLoggedUser, dashboard, storeTokenInLS }}>
				{children}
			</AuthContext.Provider>
		</>
	);
};

export const useAuth = () => {
	const authContext = useContext(AuthContext);

	if (!authContext) {
		throw new Error("useAuth must be used within an AuthProvider");
	}

	return authContext;
};
